// eslint-disable-next-line jira/filename-case
import React, { useRef } from 'react';
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
import { useEntryPoint } from '@jira/platform__entry-point/src/controllers/use-entry-point/index.tsx';
import { JiraEntryPointContainer } from '@jira/platform__entry-points-container/src/index.tsx';
import { useIsStagingOrDevOrLocal } from '@atlassian/jira-tenant-context-controller/src/components/environment/index.tsx';
import { ssrFailureDisplayEntryPoint } from './ssrFailureDisplayEntryPoint.entrypoint.tsx';

const EMPTY_OBJECT = {};

const LoadEntryPoint = () => {
	const hasLoadedEntryPoint = useRef(false);

	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		ssrFailureDisplayEntryPoint,
		EMPTY_OBJECT,
	);

	// Docs say to do this not in an effect :/ https://hello.atlassian.net/wiki/spaces/UAF/pages/2333138515/Deprecated+Tutorial+How+to+render+your+EntryPoint+for+async+components#Option-3%3A-Using-useRef-without-user-interaction
	// And they have eslint rules to enforce it
	if (!hasLoadedEntryPoint.current) {
		hasLoadedEntryPoint.current = true;
		entryPointActions.load();
	}

	return (
		<JiraEntryPointContainer
			id="ssr-failure-display"
			packageName="@jira/ssr__rendering-guard"
			entryPointReferenceSubject={entryPointReferenceSubject}
			runtimeProps={EMPTY_OBJECT}
		/>
	);
};

export const AsyncSSRFailureDisplay: {
	(): React.JSX.Element | null;
	displayName: string;
} = (): React.JSX.Element | null => {
	const isStagingOrDevOrLocal = useIsStagingOrDevOrLocal();
	if (isStagingOrDevOrLocal) {
		return <LoadEntryPoint />;
	}
	return null;
};

AsyncSSRFailureDisplay.displayName = 'AsyncSSRFailureDisplay';
